import React from "react";
import Radium from "radium";
import { Link } from "react-router-dom";

import styles from "./FooterStyle";

class Footer extends React.Component {
  render() {
    return (
      <div style={styles.footer}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12 col-md-offset-1 col-md-3">
              <div style={styles.footerHeader}>QUICK LINKS</div>
              <Link style={styles.footerLink} to="/products">
                Our Products
              </Link>
              <Link style={styles.footerLink} to="/services">
                Our Services
              </Link>
              <Link style={styles.footerLink} to="/about">
                About Us
              </Link>
              <a style={styles.footerLink} target="_blank" href="/assets/Code Of Ethics.pdf">
                Code Of Ethics
              </a>
              {/*<Link style={styles.footerLink} to="/blog">Blog</Link>*/}
            </div>
            <div className="col-xs-12 col-md-offset-1 col-md-3">
              {/*<div style={styles.footerHeader}>LATEST BLOG POSTS</div>
                            <Link style={styles.footerLink} to="/blog/1">Placeholder article</Link>
                            <Link style={styles.footerLink} to="/blog/2">Placeholder article 2</Link>
                            <Link style={styles.footerLink} to="/blog/3">Placeholder article 3</Link>*/}
            </div>
            <div className="col-xs-12 col-md-offset-1 col-md-3">
              <div style={styles.footerHeader}>CONTACT</div>
              <a style={styles.footerLink} href="mailto:contact@aethilus.com">
                contact@aethilus.com
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js